<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="shadow-btm">
          <div class="row">
            <div class="col-lg-12 col-sm-12 my-auto d-flex align-items-center mb-4">
              <a class="pr-2 text-dark cursor-pointer" @click="$router.push('/languages')">
                <span class="font-24 mr-2"><img src="/images/back-arrow.svg" width="18" /></span>
              </a>
              <h4 class="mb-0 lg-bld">{{ id ? "Edit" : "Add" }} Language</h4>
            </div>
          </div>
        </div>

        <div class="page-content">
          <div class="card-body py-0 px-0">
            <div class="card border mb-0 radius-15">
              <div class="card-body">
                <Form ref="languageForm" @submit="save">
                  <div class="row">
                    <div class="col-lg-6 col-sm-6">
                      <div class="form-group">
                        <label>Name</label>
                        <span class="text-danger">*</span>
                        <Field
                          type="text"
                          name="language_name"
                          class="form-control"
                          placeholder="Language Name"
                          v-model="detail.name"
                          rules="required:Language Name"
                          :validateOnInput="true"
                        />
                        <ErrorMessage name="language_name" class="text-danger" />
                      </div>
                    </div>
                    <div class="col-lg-12 col-sm-12 text-center mt-2">
                      <button type="submit" id="save-button" class="save-btn px-4 ml-3">Save</button>
                      <button type="button" class="fil-btn px-4 ml-3" @click="$router.go(-1)">Cancel</button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ErrorComponent @retry="getDetail" ref="errorComponent" />
  </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import ErrorComponent from "@/components/ErrorComponent";

export default {
  name: "AddEditLanguage",
  components: { Form, Field, ErrorMessage, ErrorComponent },
  data() {
    return {
      id: this.$route.params.id,
      detail: {},
    };
  },
  mounted() {
    if (this.id) this.getDetail();
  },
  methods: {
    getDetail() {
      this.$refs.errorComponent.updateFormLoader(true);
      this.$api
        .getAPI({ _action: "/languages/detail/" + this.id })
        .then((res) => {
          this.detail = res;
          this.$refs.errorComponent.setData(res, "null");
          this.$refs.errorComponent.updateFormLoader(false);
        })
        .catch(() => {
          this.$refs.errorComponent.setData(0, undefined, "");
          this.$refs.errorComponent.updateFormLoader(false);
        });
    },
    save() {
      if (this.id) {
        this.$api
          .putAPI({
            _action: "/languages/edit/" + this.id,
            _body: this.detail,
            _buttonId: "save-button",
          })
          .then((res) => {
            this.$router.go(-1);
            this.$notify({
              type: "success",
              text: res.message,
            });
          })
          .catch(() => {});
      } else {
        this.$api
          .postAPI({
            _action: "/languages/add",
            _body: this.detail,
            _buttonId: "save-button",
          })
          .then((res) => {
            this.$router.go(-1);
            this.$notify({
              type: "success",
              text: res.message,
            });
          })
          .catch(() => {});
      }
    },
  },
};
</script>
